
import { mapActions } from "vuex";
import AOS from 'aos'
import 'aos/dist/aos.css'


export default {
	data() {
		return {
			initSlider: false
		}
	},
	props: {
		benefits: Array,
		hasModal: {
			type: Boolean,
			default: true
		},
		modal: {
			type: Boolean,
			default: false
		},
		position: {
			type: String,
			default: 'static'
		},
		catalog: {
			type: Boolean,
			default: false
		},
		hideButtonOnMobile: {
			type: Boolean,
			default: false
		},
		paddingAsLine: {
			type: Boolean,
			default: true
		}
	},
	methods: {
		...mapActions({
			openBenefit: 'benefits/openBenefit'
		})
	},


	mounted() {

		setTimeout(() => {
			new swiper.default('.swiper--benefits.swiper', {
				modules: [swiper.Navigation, swiper.Autoplay],
				loop: true,
				// autoplayDisableOnInteraction: true,
				autoplay: {
					delay:1500	
				},
				initialSlide: 0,
				// centeredSlides: true,
				watchSlidesProgress: true,
				// centeredSlidesBounds:true,
				// roundLengths: true,

				// centerInsufficientSlides:true,
				// slidesOffsetAfter: this.$refs.benefitsSlider.getBoundingClientRect().left,
				// cssMode:true,
				slidesPerView: 1.5,
				spaceBetween: 20,
				// slidesOffsetBefore: leftPadding,
				// slidesOffsetAfter: leftPadding,
				breakpoints: {
					// when window width is >= 320px

					600: {
						slidesPerView: 3,
						spaceBetween: 24,

						// slidesOffsetBefore: leftPadding,

					}

				},
				navigation: {
					nextEl: '.catalog__buttons .swiper-button-next--benefits',
					prevEl: '.catalog__buttons .swiper-button-prev--benefits',
				},
				on: {
					init: (value) => {
						this.initSlider = true
					}
				}
			});
		})

	},
}
